import * as React from 'react'

export interface FieldContext {
  orientation: 'horizontal' | 'vertical'
  size: 'sm' | 'md'
}

export const FieldContext = React.createContext<FieldContext | null>(null)

export function useFieldContext() {
  const context = React.useContext(FieldContext)
  if (!context) {
    throw new Error('useFieldContext must be used within <Field.Root>')
  }
  return context
}
